module.exports = __webpack_public_path__ + "static/img/404.3ffcfb4.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build821/assets/image/404/404.png
// module id = u7qF
// module chunks = 0 58